<template>
  <!-- DVL-010: other ways to reach the manager, next to the chat. Hidden until the backoffice sets one. -->
  <div v-if="links.length" class="contact-links" data-testid="support-contact-links">
    <span class="contact-links__title">{{ t('support.contact.title') }}</span>
    <!-- One row of pills sized to their names: a narrow screen (a folded phone) drops the icons instead of
         wrapping one pill alone onto a second line. -->
    <div class="contact-links__row">
      <a
        v-for="l in links" :key="l.kind"
        :href="l.href"
        :target="l.kind === 'email' ? undefined : '_blank'"
        rel="noopener noreferrer"
        class="contact-links__pill"
        :data-testid="`support-contact-${l.kind}`"
      >
        <IconSend v-if="l.kind === 'telegram'" :size="14" />
        <IconChat v-else-if="l.kind === 'whatsapp'" :size="14" />
        <IconMail v-else :size="14" />
        <span class="contact-links__label">{{ t(`support.contact.${l.kind}`) }}</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useContactChannels } from '@/composables/useContactChannels';
import { IconChat, IconMail, IconSend } from '@/components/ui/icons';

const { t } = useI18n();
const { links } = useContactChannels();
</script>

<style scoped lang="scss">
.contact-links {
  display: flex; flex-direction: column; gap: 6px;
  padding: 8px 16px;
  background: var(--bg-card); border-bottom: 1px solid var(--hairline);
  container-type: inline-size;
}
.contact-links__title { font-size: 12px; color: var(--text-3); }
.contact-links__row { display: flex; gap: 6px; }
.contact-links__pill {
  flex: 1 1 auto; min-width: 0;
  display: inline-flex; align-items: center; justify-content: center; gap: 5px;
  min-height: 32px; padding: 0 8px; border-radius: 100px;
  background: var(--bg-elev); border: 1px solid var(--hairline);
  color: var(--text); font-size: 12.5px; text-decoration: none;
  svg { color: var(--gold); flex: none; }
}
.contact-links__label { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* Too narrow for icon and name side by side: the name is what tells the channels apart. */
@container (max-width: 310px) {
  .contact-links__pill svg { display: none; }
}
</style>
